export const WIFICALL_PLANS_URL = `planlist`;